@if (envRibbon; as env) {
<div class="env-ribbon">{{ env }}</div>
}
<router-outlet />
